import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FaqService } from '../../services/faq.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { CommonService } from 'src/app/services/common.service';
import { SidenavService } from 'src/app/services/sidenav.service';
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';
@Component({
  standalone: false,
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FaqComponent implements OnInit {
  openOptionDrawer: boolean = false;
  content: any[];
  faqEdit: any;
  faqRemove: any;

  constructor(
    private apiService: FaqService,
    private router: Router,
    private appStateSrv: AppStateProvider,
    private commonService: CommonService,
    private sideNavService: SidenavService,
    private rolebasedactionService: RolebasedactionService,
  ) {
    const route = this.sideNavService.routingChunks({ name: 'FAQs' });
    // this.appStateSrv.setSideNavState(route);
  }

  ngOnInit(): void {
    this.faqEdit = this.rolebasedactionService.checkUserRolePermissionExits('FAQ:Edit');
    this.faqRemove = this.rolebasedactionService.checkUserRolePermissionExits('FAQ:Remove');
    if (localStorage.getItem('parkId') == '' && localStorage.getItem('claAdminId')) {
      this.getParkbyClaId()
    }
    this.getFaq();
    localStorage.removeItem('expandNav');
  }

  getFaq() {
    this.apiService.getFaqs().subscribe((res) => {
      console.log(res);
      this.content = res;
    });
  }

  deleteFaq(data) {
    this.apiService.deleteFaq(data).subscribe((res) => {
      this.getFaq()
    });
  }

  edit(id) {
    this.router.navigate(['/faq/edit-faq', id]);
  }

  addFaq() {
    this.router.navigate(["/faq/add-faq"])
  }


  //dropdown fix test
  getParkbyClaId() {
    this.commonService.getParkByCLAId().subscribe(res => {
      console.log(res);
      if (res.isValid) {
        // localStorage.setItem('parkId', res.list[0].parkId)
        localStorage.setItem('parkDropDownDetails', JSON.stringify(res.list))
      }
    });
  }

  //UI functionality

  openPopover(popover: any) {
    if (!popover || typeof popover.isOpen !== 'function') {
      return;
    }
    try {
      if (popover.isOpen()) {
        popover.close();
      } else {
        popover.open();
      }
    } catch (error) {
      console.error('Error toggling popover:', error);
    }
  }

  closePopover(popover: any) {
    if (!popover || typeof popover.close !== 'function') {
      return;
    }
    try {
      popover.close();
    } catch (error) {
      console.error('Error closing popover:', error);
    }
  }

}
